import { URLData } from "./useContextAPI";

export const isURLData = (data: any): data is URLData => {
  return ["url", "label"].includes(data?.type);
};
